module.exports = __webpack_public_path__ + "static/media/ic_arrow_l.7a7db2f6.svg";